<ion-header class="ion-no-border">
    <ion-toolbar>

        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

        <ion-title>Choose date</ion-title>

        <ion-buttons slot="end">
            <ion-button *ngIf="clear_date" (click)="clearDate()">
                <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
                <span>Clear</span>
            </ion-button>
            <ion-button (click)="selectDate()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid >
        <ion-col class="ion-no-padding">
            <ion-row>
                <ion-datetime *ngIf="format == 'date-time'" presentation="date-time" size="cover" firstDayOfWeek="1" fill="outline" [(ngModel)]="params.date"></ion-datetime>
                <ion-datetime *ngIf="format == 'date'" presentation="date" size="cover" firstDayOfWeek="1" fill="outline" [(ngModel)]="params.date"></ion-datetime>
            </ion-row>
        </ion-col>
    </ion-grid>
</ion-content>